module.exports = __webpack_public_path__ + "static/img/about-list1.7f6c91a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-list1.png
// module id = H+vX
// module chunks = 0